import React from 'react';

import SmartImage from 'dpl/components/SmartImage';
import useBreederProfileTabs from 'dpl/components/BreederProfile/hooks/useBreederProfileTabs';
import { MOBILE_TAB_KEYS } from 'dpl/components/BreederProfile/utils/constants';

import { useBreederProfileData } from '../../hooks/useBreederProfileData';
import WorkingWithBreederButton, {
  WorkingWithBreederButtonContent
} from './WorkingWithBreederButton';

const ICON_NAME = 'fetch-arrow-right-md';

export default function MeetBreederButton() {
  const { breeder, isFetchingBreeder } = useBreederProfileData();
  const { replaceHash } = useBreederProfileTabs();

  if (isFetchingBreeder) {
    return null; // TODO: skeleton
  }

  const title = 'Meet the breeder';
  const subtitle = `Learn more about ${breeder.user.first_name} and their breeding program.`;

  function handleButtonClick() {
    replaceHash(MOBILE_TAB_KEYS.ABOUT);
    window.scrollTo(0, 0);
  }

  if (breeder.meet_breeder_photo_url) {
    return (
      <button
        type="button"
        className="mt2 br4 w-100 overflow-hidden"
        onClick={handleButtonClick}
      >
        <div className="relative">
          <div className="aspect-ratio aspect-ratio--1x1">
            <div className="aspect-ratio--object">
              <SmartImage
                Tag="div"
                className="w-100 h-100 cover bg-center"
                src={breeder.meet_breeder_photo_url}
              />
            </div>
          </div>
          <div
            className="flex items-center gap-8 absolute bottom-0 bg-white br12 ph4 pv4 mh2 mv2"
            style={{ zIndex: 100 }}
          >
            <WorkingWithBreederButtonContent
              title={title}
              subtitle={subtitle}
              iconName={ICON_NAME}
            />
          </div>
        </div>
      </button>
    );
  }

  return (
    <WorkingWithBreederButton
      title={title}
      subtitle={subtitle}
      iconName={ICON_NAME}
      onClick={handleButtonClick}
    />
  );
}
